import '../../modules/mode-components';

import * as angular from 'angular';

import template from './create-org-modal.html';

const createOrgModalDirective = function (Modal) {
  return {
    restrict: 'A',
    link: function ($scope: any, elem, attrs) {
      elem.on('click.createOrg', (event) => {
        const modal = Modal.open(
          {},
          {
            template: template,
          }
        );
      });

      // cleanup handlers
      $scope.$on('$destroy', () => elem.off('click.createOrg'));
    },
  };
};

createOrgModalDirective.$inject = ['ModalService'];

angular.module('mode.components').directive('createOrgModal', createOrgModalDirective);
